module.exports = __webpack_public_path__ + "static/img/huaweiMateBook14.2f2547c9.png";